export default __webpack_public_path__ + "static/media/SaraKiselovska.559402c0.png";